import elementSettings from 'src/js/modules/element-settings';
import controlIds from '../constants/control-ids';
import {
  cornerTargets,
  borderTargets,
  shadowTargets,
  verticalSpacingTargets,
  horizontalSpacingTargets,
} from '../constants/targets';
import settingIds from '../constants/setting-ids';
import getColorScheme from './color-scheme';
import getHorizontalContentAlignment from './horizontal-content-alignment';
import getVerticalContentAlignment from './vertical-content-alignment';

const {
  constants: { targetClasses },
  helpers: { getTargetElementIds },
} = elementSettings;

const getColumnControlSettings = (elementId) => {
  const settingId = settingIds.THIS_COLUMN;
  const elementIds = getTargetElementIds(elementId);

  return {
    [controlIds.COLOR_SCHEME]: getColorScheme(settingId, {
      elementIds,
    }),
    [controlIds.HORIZONTAL_CONTENT_ALIGNMENT]: getHorizontalContentAlignment(settingId, {
      elementIds,
    }),
    [controlIds.VERTICAL_CONTENT_ALIGNMENT]: getVerticalContentAlignment(settingId, {
      elementIds,
    }),
    [controlIds.BORDER]: {
      elementIds,
      targets: borderTargets,
    },
    [controlIds.SHADOW]: {
      elementIds,
      targets: shadowTargets,
    },
    [controlIds.VERTICAL_SPACING]: {
      elementIds,
      targets: verticalSpacingTargets,
    },
    [controlIds.HORIZONTAL_SPACING]: {
      elementIds,
      targets: horizontalSpacingTargets,
    },
    [controlIds.COLUMN_WIDTH]: {
      elementIds,
      targets: [targetClasses.GROW],
    },
    [controlIds.CORNERS]: {
      elementIds,
      targets: cornerTargets,
    },
  };
};

export default getColumnControlSettings;
